import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule, BrowserTransferStateModule } from "@angular/platform-browser";
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION } from 'ngx-ui-loader';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ConfigService } from "./service/config.service";
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { MyinterceptorService } from './myinterceptor.service';
import { ClipboardModule } from 'ngx-clipboard';
import { LangService } from "./service/lang.service";
import { SharedWebModule } from './web/shared/shared.web.module';
import { HomeModule } from './web/home/home.module';
import { TranslateService, TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "src/environments/environment";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'rgba(12,80,219,0.98)',
  bgsOpacity: 1,
  bgsPosition: POSITION.centerCenter,
  bgsSize: 40,
  bgsType: SPINNER.ballSpinClockwise,
  fgsSize: 40,
  fgsColor: '#2494d8',
  fgsPosition: POSITION.centerCenter,
  text: 'Loading...',
  hasProgressBar: false, 
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    BrowserTransferStateModule,
    BrowserAnimationsModule,
    ClipboardModule,
    // TranslateModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    SharedModule,
    NgxDaterangepickerMd.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    SharedWebModule,
    HomeModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [TranslateService, LangService, ConfigService],
      useFactory: appInitializerFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyinterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

export function translateLoaderFactory(httpClient: HttpClient): TranslateLoader {
  let path = '';
  if (window.location.hostname === 'localhost') {
    path = './assets/i18n/';
  } else {
    let webUrl = environment.WEB_URL;
    const hostnameHasWWW = window.location.hostname.startsWith('www.');
    if (hostnameHasWWW && !webUrl.includes('www.')) {
      const urlParts = webUrl.split('//');
      webUrl = urlParts[0] + '//www.' + urlParts[1];
    } else if (!hostnameHasWWW && webUrl.includes('www.')) {
      webUrl = webUrl.replace('www.', '');
    }
    path = webUrl + 'assets/i18n/';
  }
  // return new TranslateHttpLoader(httpClient, path, `.json?ts=${new Date().getTime()}`);
  return new TranslateHttpLoader(httpClient, path, '.json');
}

export function appInitializerFactory(translate: TranslateService, langService: LangService, configService: ConfigService) {
  return () => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0] || '';
    const isCardRoute = pathSegments.length === 1 && !['home', 'auth', 'product', 'user'].includes(firstSegment);

    const initTranslatePromise = new Promise<void>((resolve, reject) => {
      translate.addLangs(['en', 'ar']);
      translate.setDefaultLang('en');
      langService.setLang('en');
      translate.use('en').subscribe(
        () => resolve(),
        err => reject(err)
      );
    });

    const promises: Promise<any>[] = [initTranslatePromise];

    if (!isCardRoute) {
      promises.push(configService.loadApplicationConfig());
      promises.push(langService.loadLanguage());
    }

    return Promise.all(promises)
      .then(() => { })
      .catch(err => {
        console.error('Initialization error:', err);
      });
  };
}
